import { notification } from "antd";
import { useEffect, useState } from "react";
import { getApiError, getMarketInfo } from "tm-shared/api";
import { Market } from "tm-shared/types";

import { useAppSelector } from "@/hooks/redux";

interface UseMarketReturn {
    market: Market | null;
    marketLoading: boolean;
}

export const useMarket = (marketId: string): UseMarketReturn => {
    const { markets } = useAppSelector((state) => state.work);

    const [market, setMarket] = useState<Market | null>(
        () => markets[marketId] ?? null,
    );
    const [marketLoading, setMarketLoading] = useState(false);

    useEffect(() => {
        const fetchMarket = async () => {
            try {
                setMarketLoading(true);
                const { result } = await getMarketInfo({ marketId });

                setMarket(result);
            } catch (error) {
                const { displayMessage } = getApiError(error);

                notification.error({
                    message: "Не вдалося завантажити маркет",
                    description: displayMessage,
                });
            } finally {
                setMarketLoading(false);
            }
        };

        if (market) return;

        fetchMarket();
    }, [marketId, market]);

    return { market, marketLoading };
};
